<template>
  <!-- <CContainer class="d-flex align-items-center min-vh-100">-->
  <div>
    <div class="d-flex h-desktop-fit">
      <CRow
        class="d-flex justify-content-center form-wrapper-mf registration-form"
      >
        <CCol md="4" class="form-left">
          <div class="form-right-title">
            {{ $t("agentRegPage.haveAcct") }}
          </div>
          <div class="form-sub-message">
            {{ $t("agentRegPage.loginHere") }}
          </div>
          <button class="mf-secondary-btn" @click="navigateToLogin">
            {{ $t("agentRegPage.login") }}
          </button>
        </CCol>

        <CCol md="8" class="mob-res-form-bg">
          <div class="logo-wrapper align-center jc-center ">
            <!-- <img src="@imgPath/img/png/Logo-Maing-Fong.jpg" alt="" /> -->
<!--             <img :src="getImage('Logo-Maing-Fong')" alt="">-->
            <span class="brand-logo">

            </span>
            <div class="form-title">
              <!-- <strong> -->
              <label>{{ $t("agentRegPage.registration") }}</label>
              <!-- </strong> -->
            </div>
          </div>

          <!-- <router-link to="/AgentLogin"></router-link> -->

          <br />

          <CCol>
            <ValidationObserver v-slot="{ handleSubmit }" col="8">
              <div class="">
                <form @submit.prevent="handleSubmit(regFormSubmit)">
                  <!-- <strong>{{$t('agentRegPage.coDetails')}}</strong> -->

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-field">
                        <cTextInputComponent
                        :id="$t('agentRegPage.agencyName')"
                        :ref="$t('agentRegPage.agencyName')"
                        :toEmit="true"
                         @caughtError="scrollToElement"
                          v-model="agentRegObj.comDet.agencyName"
                          :placeholder="$t('agentRegPage.agencyPlace')"
                          :name="'agentRegistration'"
                          :vid="$t('agentRegPage.agencyName')"
                          :label="$t('agentRegPage.agencyName')"
                          rules="noInitialSpace|required|max:50"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-field">
                        <cTextInputComponent
                        :id="$t('agentRegPage.busRegNo')"
                        :ref="$t('agentRegPage.busRegNo')"
                        :toEmit="true"
                         @caughtError="scrollToElement"
                          v-model="agentRegObj.comDet.buisnessRegNo"
                          :placeholder="$t('agentRegPage.busRegPl')"
                           :name="'agentRegistration'"
                             :vid="$t('agentRegPage.busRegNo')"
                          :label="$t('agentRegPage.busRegNo')"
                          rules="required|Atmax:30|no_space|alpha_num"
                        />
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-field">
                        <cTextInputComponent
                          v-model="agentRegObj.comDet.IATANumber"
                          :placeholder="$t('agentRegPage.iataNoPl')"
                           :name="'agentRegistration'"
                             :vid="$t('agentRegPage.iataNo')"

                          :label="$t('agentRegPage.iataNo')"
                          rules="Uptomax:4|nospace|alphanum"
                        />
                      </div>
                      <br />
                      <strong>{{ $t("agentRegPage.contDet") }}</strong>
                    </div>

                    <div class="col-md-12">
                      <br />
                    </div>
                    <div class="col-md-6">
                      <div class="form-field">
                        <cTextInputComponent
                        :id="$t('agentRegPage.agtName')"
                        :ref="$t('agentRegPage.agtName')"
                        :toEmit="true"
                         @caughtError="scrollToElement"
                          v-model="agentRegObj.contDet.name"
                          :placeholder="$t('agentRegPage.namePl')"
                           :name="'agentRegistration'"
                            :vid="$t('agentRegPage.agtName')"
                          :label="$t('agentRegPage.agtName')"
                          rules="noInitialSpace|required|Maximum:30|onlyAlphabets"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-field address-wrap-field">
                        <cMultiLineText
                          v-model="agentRegObj.contDet.address"
                          :placeholder="$t('agentRegPage.adrsPl')"
                           :name="'agentRegistration'"
                            :vid="$t('agentRegPage.agtAdrs')"
                          :label="$t('agentRegPage.agtAdrs')"
                          rules="noInitialSpace|Uptomax:150|required"
                          :toEmit="true"
                         @caughtError="scrollToElement"
                         :id="$t('agentRegPage.agtAdrs')"
                        :ref="$t('agentRegPage.agtAdrs')"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-field">
                        <cTextInputComponent
                        :id="$t('agentRegPage.agtCity')"
                        :ref="$t('agentRegPage.agtCity')"
                        :toEmit="true"
                         @caughtError="scrollToElement"
                          v-model="agentRegObj.contDet.city"
                          :placeholder="$t('agentRegPage.cityPl')"
                           :name="'agentRegistration'"
                            :vid="$t('agentRegPage.agtCity')"
                          :label="$t('agentRegPage.agtCity')"
                          rules="noInitialSpace|required|Maximum:30|onlyAlphabets"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div
                        class="form-field country-name"
                        v-if="agentRegObj.contDet.showState"
                      >
                        <cDropDown
                          key="state"
                          :id="$t('agentRegPage.agtState')"
                        :ref="$t('agentRegPage.agtState')"
                        :toEmit="true"
                         @caughtError="scrollToElement"
                          :label="$t('agentRegPage.agtState')"
                          :ctrlName="'statename'"
                          :ctrlCode="'statecode'"
                          :showError="false"
                          :isShowCode="true"
                          :isMultiple="false"
                          :isSearchable="true"
                          :url="getStateServiceURL()"
                          :cntryCode="agentRegObj.contDet.selCountryObj"
                          v-on:input="onStateChange"
                          :selValue="agentRegObj.contDet.state"
                          rules="required"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-field country-name">
                        <cDropDown
                          key="country"
                          :label="$t('agentRegPage.agtCountry')"
                          :ctrlName="'value'"
                          :ctrlCode="'countrycode'"
                          :isShowCode="true"
                          :isMultiple="false"
                          :isSearchable="true"
                          :isAllowEmpty="false"
                          :url="getCountryServiceURL()"
                          rules="required"
                          v-on:input="onCountryChange"
                          :selValue="agentRegObj.contDet.selCountryObj"
                        />
                      </div>
                    </div>
                    <!-- {{agentRegObj.contDet.selCountryObj}} -->
                    <!-- <cDropDown
                      v-model="agentRegObj.contDet.country.value"
                      :option="agentRegObj.contDet.cntryRes"
                      :name="$t('agentRegPage.agtCountry')"
                    />-->
                    <!-- {{this.agentRegObj.contDet.country.value}} -->
                    <div class="col-md-6">
                      <div class="form-field ">
                        <cTextInputComponent

                           :upperCase='true'
                          v-model="agentRegObj.contDet.postCode"
                          :placeholder="$t('agentRegPage.postPl')"
                           :name="$t('agentRegPage.agtPostal')"
                            :vid="$t('agentRegPage.agtPostal')"
                          :label="$t('agentRegPage.agtPostal')"
                          rules="validPstlCode"
                        />
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-field">
                        <cTextInputComponent
                         :id="$t('agentRegPage.emailName')"
                        :ref="$t('agentRegPage.emailName')"
                        :toEmit="true"
                         @caughtError="scrollToElement"
                          v-model="agentRegObj.contDet.email"
                          :placeholder="$t('agentRegPage.mailPl')"
                           :name="'agentRegistration'"
                          :vid="$t('agentRegPage.emailName')"

                          :label="$t('agentRegPage.emailName')"
                          rules="required|email"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- {{agentRegObj.contDet.selMobileCodeObj}} -->
                 <div class="form-field mb-0"> <label>{{ $t("agentRegPage.agtMblNo") }}</label> </div>

                  <CRow class="mobile-number-reg inner-label-none">
                    <div class="country-code">
                      <div class="form-field">
                        <cDropDown
                          class="dpTopalign"
                          key="mobilecode"
                          :isAllowEmpty="false"
                          :ctrlName="'calling_code'"
                          :ctrlCode="'countrycode'"
                          :isShowCode="false"
                          :isMultiple="false"
                          :isSearchable="true"
                          :url="getCountryServiceURL()"
                          rules="required"
                          :selValue="agentRegObj.contDet.selMobileCodeObj"
                        />
                      </div>
                    </div>
                    <div class="mob-no ">
                      <div class="form-field">
                        <cTextInputComponent
                         :id="$t('agentRegPage.mblPl')"
                        :ref="$t('agentRegPage.mblPl')"
                        :toEmit="true"
                         @caughtError="scrollToElement"
                          v-model="agentRegObj.contDet.mblNo"
                          :placeholder="$t('agentRegPage.mblPl')"
                          rules="required|onlyNumber|Uptomax:15|minimum:4"
                        />
                      </div>
                    </div>
                  </CRow>
                    <br />
                  <strong>{{ $t("agentRegPage.logDet") }}</strong>
                  <div class="col-md-12">
                    <br />
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-field">
                        <cTextInputComponent
                          v-model="agentRegObj.logDet.logMail"
                          :placeholder="$t('agentRegPage.logPl')"
                           :name="'agentRegistration'"
                              :vid="$t('agentRegPage.logMail')"

                          :label="$t('agentRegPage.logMail')"
                          :isAutoComplete="false"
                          rules="required|email"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-field">
                        <cTextInputComponent
                          v-model="agentRegObj.logDet.logPwd"
                          :placeholder="$t('agentRegPage.pwdPl')"
                           :name="'agentRegistration'"
                          :vid="$t('agentRegPage.logPwd')"

                          :label="$t('agentRegPage.logPwd')"
                          type="password"
                          :isAutoComplete="false"
                          rules="required|agt_pwd"
                        />
                      </div>
                       <!-- rules="noSpace|required|min:8|letter|number|oneSplChar|Pswdmax:20" -->
                    </div>
                  </div>
                  <CRow>
                    <div class="captcha col-md-6">
                      <CCol class="dpTopalign">
                        <div class="form-field grey-border-mf">
                          <cCaptcha ref="captchaComponent"  iconName="cil-reload" />
                          <!-- </div> -->
                          <!-- </div> -->
                        </div>
                      </CCol>
                      <CCol>
                        <!-- <div class="input-group col-xs-5 col-sm-26"> -->

                        <!-- <div class="form-control "> -->
                        <div class="form-field">
                          <cTextInputComponent
                            v-model="agentRegObj.logDet.captcha"
                            :placeholder="$t('agentRegPage.cptPl')"
                           :name="'agentRegistration'"
                                                     :vid="$t('agentRegPage.captcha')"

                            :label="$t('agentRegPage.captcha')"
                            rules="required"
                          />
                        </div>
                        <!-- <div class="input-group-text">
                      <cCaptcha iconName="cil-check" />
                        </div>-->
                        <!-- </div> -->
                        <!-- <div class="input-group-text">  -->
                      </CCol>
                    </div>
                    <div class="col-md-6 submit-reg-btn">
                      <CCol class="text-right pd0">
                        <CButton
                          pressed
                          block
                          type="submit"
                          class="btn-primary-mf"
                          >{{ $t("agentRegPage.submit") }}</CButton
                        >
                      </CCol>
                    </div>
                  </CRow>
                  
                  <div v-if="showAlert">
                    <CAlert show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>
                     
                  </div>
              

                </form>
              </div>
            </ValidationObserver>
          </CCol>
        </CCol>
      </CRow>
    </div>
    <cAlertModal
      :buttonList="[
        {
          name: $t('agentRegPage.backTo') + ' ' + $t('agentRegPage.home'),
          func: navigateToLogin,
          color: 'success'
        }
      ]"
      :status="1"
      :show="regSubmitted"
      :desc="$t('agentRegPage.thnkyou')"
    ></cAlertModal>
  </div>
  <!--</CContainer> -->
</template>

<script>
import { PAGE_NAME, PATHNAME, ALL_CLIENT_CODE } from "../../util/constants.js";
import BaseConfiguration from "../../config/base.js";
import { ValidationObserver, localize } from "vee-validate";
import cTextInputComponent from "../../components/form/cTextInputComponent";
import cCaptcha from "../../components/form/cCaptcha";
import cDropDown from "../../components/form/cDropDown";
import cAlertModal from "../../components/form/cAlertModal";
import cMultiLineText from "../../components/form/cMultiLineText";
import { mapActions } from "vuex";
import router, { navigate, goBack } from "../../router/index";
import { mapGetters } from "vuex";
// import nb from "../../translations/validation/nb.json";
// import en from "../../translations/validation/en.json";
import apiGetCountryList from "../../services/apiGetCountryList.js";
import apiCreateAgent from "../../services/apiCreateAgent.js";
import Logger from "../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import { Agent } from "http";
import { COMPONENT_NAME } from "@/util/constants.js";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import { handleJWT, getErrorAlertValue ,addClassToBody,removeClassBody} from "../../util/util";
import SERVICE_URL from "../../config/API_DATA";
// localize({
//   en: {
//     messages: en.messages.AgentRegistration
//   },
//   nb: {
//     messages: nb.messages.AgentRegistration
//   }
// });
export default {
  name: COMPONENT_NAME.AGENT_REGISTRATION,
  components: {
    ValidationObserver,
    cTextInputComponent,
    cCaptcha,
    cMultiLineText,
    cAlertModal,
    cDropDown
  },
  data: () => ({
    regSubmitted: false,
    alertValue: null,

    showAlert: false,
    closeOnBack: false,
    counter: 73,
    max: 100,
    max2: 50,
    value: 33.333333333,
    value3: 75,
    bars: [
      {
        color: "success",
        value: 75
      },
      {
        color: "info",
        value: 75
      },
      {
        color: "warning",
        value: 75
      },
      {
        color: "danger",
        value: 75
      },
      {
        color: "primary",
        value: 75
      },
      {
        color: "secondary",
        value: 75
      },
      {
        color: "dark",
        value: 75
      }
    ],
    timer: null,
    striped: true,
    animate: true,
    max3: 100,
    values: [15, 30, 20],

    agentRegObj: {
      comDet: {
        agencyName: null,
        buisnessRegNo: null,
        IATANumber: null
      },
      contDet: {
        name: null,
        address: null,
        city: null,
        showState: false,
        state: null,
        mblNo: null,

        selCountryObj: {
          countrycode: null,
          value: null,
          calling_code: null
        },
        selMobileCodeObj: {
          countrycode: null,
          value: null,
          calling_code: null
        },
        cntryRes: [],
        postCode: null,
        email: null,
        org: API_VALUES.ORG_ID
      },
      logDet: {
        logMail: null,
        logPwd: null,
        captcha: null,
        captchaTxt: null
      }
    }
  }),
  // watch: {
  //     alertValue(value) {
  //         if(this.alertValue=='expired captcha'){
            
  //         }
  //       },
  //   },
  methods: {
    ...mapActions("sAgtReg", ["SET_AGENCY_DET"]),
    ...mapActions("sAgtReg", ["CLEAR_AGT_REG_STORE"]),

    ...mapActions("sAgtReg", ["SET_AGENCY_REQ"]),
    ...mapActions("sAgtReg", ["SET_AGENCY_RES"]),

    scrollToElement(pRef) {
                var el = null;
                if(pRef == this.$t('agentRegPage.agencyName')) { 
                     el = this.$refs[this.$t('agentRegPage.agencyName')];
                }
                if(pRef == this.$t('agentRegPage.busRegNo')) { 
                     el = this.$refs[this.$t('agentRegPage.busRegNo')];
                }
                if(pRef == this.$t('agentRegPage.agtName')) { 
                     el = this.$refs[this.$t('agentRegPage.agtName')];
                }
                if(pRef == this.$t('agentRegPage.agtCity')) { 
                     el = this.$refs[this.$t('agentRegPage.agtCity')];
                }
                if(pRef == this.$t('agentRegPage.emailName')) { 
                     el = this.$refs[this.$t('agentRegPage.emailName')];
                }
                if(pRef == this.$t('agentRegPage.mblPl')) { 
                     el = this.$refs[this.$t('agentRegPage.mblPl')];
                }
                if(pRef == this.$t('agentRegPage.agtState')) { 
                     el = this.$refs[this.$t('agentRegPage.agtState')];
                }
                if(pRef == this.$t('agentRegPage.agtAdrs')) {
                     el = this.$refs[this.$t('agentRegPage.agtAdrs')];
                }
                if (el) {
                   
                    if(el[0]){
                        el[0].$el.scrollIntoView({ behavior: "smooth" });
                    }else{
                        el.$el.scrollIntoView({ behavior: "smooth" });
                    }
                }
  },

    captchaError(pErrorCode) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("captchaError");
          // if(pErrorCode=='CAP1') {
            this.$refs.captchaComponent.newCaptcha();
            this.agentRegObj.logDet.captcha=null;
          // }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.AGENT_REGISTRATION,
                  "error in captchaError",
                  err.toString(),
                  "captchaError",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    }, 

     /*getImage(pCode) {
      let retValue
        try {
          if(BaseConfiguration.isDebug) console.log("getImage");
        //  if(BaseConfiguration.clientCode == ALL_CLIENT_CODE.AZ)
        //   retValue= "@/assets/az/img/png/Logo-Maing-Fong.jpg"
        //  else if(BaseConfiguration.clientCode == ALL_CLIENT_CODE.MF)
        //   retValue= "@imgPath/img/png/Logo-Maing-Fong.jpg"
        if(BaseConfiguration.clientCode == ALL_CLIENT_CODE.AZ) {
         var images = require.context(
                  "@/assets/az/img/png/",
                  false,
                  /\.jpg$/
              );
              return images("./" + "logo"+ ".jpg");
        }
        else if(BaseConfiguration.clientCode == ALL_CLIENT_CODE.MF) {
         var images = require.context(
                 "@imgPath/img/png/",
                  false,
                  /\.jpg$/
              );
              return images("./" + pCode+ ".jpg");
        }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.AGENT_REGISTRATION,
                  "error in getImage",
                  err.toString(),
                  "getImage",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         // return retValue;
      }, */


    navigateToLogin: function() {
      navigate(PATHNAME.AGENT_LOGIN);
    },
    getCountryServiceURL() {
      if (BaseConfiguration.isDebug) console.log("getCountryServiceURL");
      return SERVICE_URL.GET_COUNTRY_LIST;
    },
    getStateServiceURL() {
      if (BaseConfiguration.isDebug) console.log("getStateServiceURL");

      return SERVICE_URL.GET_STATE_LIST;
    },
    regFormSubmit: async function() {
      // alert(this.alertValue)
     
      this.SET_AGENCY_DET(this.agentRegObj);
      
      let AgentRes = await this.createAgentRes();
    },
   

    async createAgentRes() {
      let retValue;
      try {
        //let langCode = get lang code
        let createAgtRequest = apiCreateAgent.buildRequest(
          this.agentRegObj,
          this.captchaText
        );
        if (BaseConfiguration.isDebug) console.log(this.agentRegObj);
            this.showAlert = false;
          
        if (createAgtRequest) {
          this.SET_AGENCY_REQ(createAgtRequest); //save req in store
          let createAgtResponse = await apiCreateAgent.getResponse(
            createAgtRequest
          );

          if (VALIDATE_SUCCESS_RES(createAgtResponse)) {
            this.SET_AGENCY_RES(createAgtResponse); //save res in store
            this.regSubmitted = true;
            retValue = createAgtResponse.data.data;
          } else {
            this.regSubmitted = false;
            this.showAlert = true;
            let error = getErrorMessage(createAgtResponse);
            
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
              
              this.captchaError(error.error[0].code);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.AGENT_REGISTRATION,
          "error in getting response from CreateAgent API",
          err.toString(),
          "CreateAgenttRes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    onStateChange(pselStateObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("onStateChange");
        this.agentRegObj.contDet.state = pselStateObj;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.AGENT_REGISTRATION,
          "error in onStateChange",
          err.toString(),
          "onStateChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onCountryChange(selCountryObj) {
      this.agentRegObj.contDet.showState = false;
      this.agentRegObj.contDet.selCountryObj = selCountryObj;
      this.agentRegObj.contDet.selMobileCodeObj = selCountryObj;
      this.agentRegObj.contDet.state = null;
      let that = this;
      setTimeout(function() {
        that.agentRegObj.contDet.showState = true;
      }); // { "countrycode": "CV", "value": "Cape Verde", "calling_code": "+238" };
    }
  },

  computed: {
    ...mapGetters("sAgtReg", {
      agents: "GET_AGENCY_DET"
    }),
    ...mapGetters("sCountryList", {
      countryRequest: "GET_COUNTRY_REQ",
      countryResponse: "GET_COUNTRY_RES"
    }),
    ...mapGetters("language", {
      lang: "GET_LANGUAGE"
    }),
    ...mapGetters("sCaptcha", {
      captchaRes: "GET_CAPTCHA_RES",
      captchaText: "GET_CAPTCHA_TEXT"
    })
  },
  async created() {
    if (this.agents != null) {
      this.agentRegObj = JSON.parse(JSON.stringify(this.agents));
    }

    // if (this.countryResponse == null) {
    //   //let countryListRes = await this.getCountryListRes();
    //   //this.agentRegObj.contDet.cntryRes = countryListRes;
    // } else {
    //   this.agentRegObj.contDet.cntryRes = this.countryResponse.data.data;
    // }
  },
   beforeCreate() {    
   addClassToBody(COMPONENT_NAME.AGENT_REGISTRATION);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
};
</script>
